// src/services/api/apiSlice.ts

import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from './baseQuery';

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: dynamicBaseQuery,
  tagTypes: [
    'Auth',
    'Dashboard',
    'TLM',
    'Student',
    'School',
    'Report',
    'MailRequest',
  ],
  endpoints: () => ({}),
});
